import { CALENDAR_GRID_LABEL_SEPARATOR } from '../../../../../constants/calendarGrid'

export function getCalendarGridWeekBlockHintAdditionalText({
  hint,
  timeLabel,
}) {
  const parts = [timeLabel]

  if (hint) {
    parts.push(hint)
  }

  return parts.join(CALENDAR_GRID_LABEL_SEPARATOR)
}
